import * as React from "react";
import { forwardRef, memo } from "react";
const SvgStatusFailed = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 1L1 13M1 1L13 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStatusFailed);
const Memo = memo(ForwardRef);
export default Memo;
